import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../../common/Constant";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";
import axios from "axios";
import config from "../../../../config/config";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import { IoIosMailOpen } from "react-icons/io";

const DriverDailySheet = () => {
  const [loading, setLoading] = useState(false);
//   const today = new Date();
//    let dates = moment(today).format("yyyy-mm-dd")
  const [ selecteddate , setselecteddate] = useState(moment().format())
  const [salesTypeID, setSalesTypeID] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");


  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "Date",
        Cell: ({ row }) =>
            moment(row.original.Date).format("MM/DD/YYYY "),
        size: 120,
      },
      {
        header: "Sale Type",
        accessorKey: "SaleType",
        size: 120,
        // filterFn: "contains",
      },
      {
        header: "Invoice #",
        accessorKey: "ID",
        // size: 150,
      },
      {
        header: "Company Name",
        accessorKey: "CompanyName",
        size: 120,
      },
      {
        header: "Total",
        accessorKey: "Total",
        size: 80,
      },
      {
        header: "Delivery Status",
        accessorKey: "DeliveryStatus",
        size: 80,
      },
      {
        header: "Route",
        accessorKey: "Route",
        size: 80,
      },
    ],
    []
  );

  const handleChangeCustomEndingDate = (value) => {
    console.log(value,"8858");
    setselecteddate(value)

  }

  const handleChangeSalesType = (event) => {
   
    setSalesTypeID(event?.value);
  };

  useEffect(() => {
    axios
    .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
    })
    .then((response) => {
      setSaletype(response.data.ResponseData);
      console.log(response.data.ResponseData, "===> setSaletype");
    })
    .catch((error) => {
      console.log(error);
    });
  },[])


  useEffect(() => {

    console.log(moment(selecteddate).format("YYYY-MM-DD"),"787");
    

    axios.get(`${config.salesconfigBaseUrl}/sales/driverdailysheet?saletime=${moment(selecteddate).format("YYYY-MM-DD")}&salestypeid=${salesTypeID}&locationid=${location}`,
        {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
    )
    .then((response) => {
        setTableData(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
  },[salesTypeID,selecteddate])

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Items</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/sales">Sales</Link>
                </li>
                <li className="breadcrumb-item active">Driver Daily Sheet</li>
              </ul>
            </div>
          </div>


          <div className="row mb-3">
          <div className="d-flex gap-2 align-items-center">
          <div style={{ width: "800px" }} className="row">
            <div className="col-md-5">  Date :  <CommonDatePicker FinalDate={selecteddate} handleDateChange={handleChangeCustomEndingDate}/> </div>
        
      <div className="col-md-5">  Sales Type:
                  <Select
                    // defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    value={salesTypeDropdownOption?.find(
                      (el) => el.value == salesTypeID
                    )}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  /> </div>
                 
            </div>
            </div>
            </div>



            <div className="card">
            <div className="card-body custom-table-css">
              <div
                className="table-responsive"
                style={{ position: "relative", zIndex: "0" }}
              >
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Inventory Print"
                  columns={columns}
                  data={tableData}
                  startdate={""}
                  enddate={""}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  isdriverdailyreport={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DriverDailySheet;
